import { useTranslation } from '@e-kyc/translations';

import { WarningRoundedIcon } from '../../../../../../components';

export function IdCardConfirmationAlert() {
  const { t } = useTranslation();

  return (
    <div className='bg-warning-100 flex items-center gap-3 px-4 py-3'>
      <WarningRoundedIcon className='text-warning-500' />
      <p className='text-body2 text-warning-900! whitespace-pre-line'>
        {t('idCardDetails.alert.warning')}
      </p>
    </div>
  );
}
